import { call, fork, take } from 'redux-saga/effects'
import { bindAsyncAction } from 'typescript-fsa-redux-saga'
import { Action } from 'typescript-fsa'

import { DeletePostRequest, GetGooglePageFeedRequest, GetGooglePageRequest } from '@3m5/sm_publish-frontend-api/apis'

import { GooglePageApi, GooglePostApi, DeferredPostApi, PostApi } from '../../api/instances'
import {
  confirmManualDeferredPost,
  confirmManualDeferredPostInitiated,
  declineManualDeferredPost,
  declineManualDeferredPostInitiated, deleteManualDeferredPost,
  deleteManualDeferredPostInitiated,
  deleteGooglePost,
  deleteGooglePostInitiated,
  getGooglePage,
  getGooglePageFeed,
  getGooglePageFeedInitiated,
  getGooglePageInitiated, retryManualDeferredPost,
  retryManualDeferredPostInitiated, updateDeferredPost,
  updateDeferredPostInitiated,
} from './googleMyBusiness.actions'
import {
  ConfirmManualDeferredPostRequest,
  DeclineManualDeferredPostRequest,
  DeleteManualDeferredPostRequest,
  RetryManualDeferredPostRequest,
  UpdateDeferredPostRequest,
} from '@3m5/sm_publish-frontend-api/apis/DeferredPostApi'

// getGooglePage
const getGooglePageWorker = bindAsyncAction(getGooglePage)(
  function * (params: GetGooglePageRequest) {
    return yield call([GooglePageApi, GooglePageApi.getGooglePage], params)
  },
)

function * watchGetGooglePageInitiated () {
  while (true) {
    const action: Action<GetGooglePageRequest> = yield take(getGooglePageInitiated)
    try {
      yield getGooglePageWorker(action.payload)
    } catch (e) {
      console.error('error in watchGetGooglePageInitiated: ', e)
    }
  }
}

// getGooglePageFeed
const getGooglePageFeedWorker = bindAsyncAction(getGooglePageFeed)(
  function * (params: GetGooglePageFeedRequest) {
    return yield call([GooglePostApi, GooglePostApi.getGooglePageFeed], params)
  },
)

function * watchGetGooglePageFeedInitiated () {
  while (true) {
    const action: Action<GetGooglePageFeedRequest> = yield take(getGooglePageFeedInitiated)
    try {
      yield getGooglePageFeedWorker(action.payload)
    } catch (e) {
      console.error('error in watchGetGooglePageFeedInitiated: ', e)
    }
  }
}

// deleteGooglePost
const deletePostWorker = bindAsyncAction(deleteGooglePost)(
  function * (params: DeletePostRequest) {
    return yield call([PostApi, PostApi.deletePost], params)
  },
)

function * watchDeletePostInitiated () {
  while (true) {
    const action: Action<DeletePostRequest> = yield take(deleteGooglePostInitiated)
    try {
      yield deletePostWorker(action.payload)
    } catch (e) {
      console.log('error in watchDeletePostInitiated: ', e)
    }
  }
}

// confirmManualDeferredPost
const confirmManualDeferredPostWorker = bindAsyncAction(confirmManualDeferredPost)(
  function * (params: ConfirmManualDeferredPostRequest) {
    return yield call([DeferredPostApi, DeferredPostApi.confirmManualDeferredPost], params)
  },
)

function * watchConfirmManualDeferredPostInitiated () {
  while (true) {
    const action: Action<ConfirmManualDeferredPostRequest> = yield take(confirmManualDeferredPostInitiated)
    try {
      yield confirmManualDeferredPostWorker(action.payload)
    } catch (e) {
      console.log('error in watchConfirmManualDeferredPostInitiated: ', e)
    }
  }
}

// declineManualDeferredPost
const declineManualDeferredPostWorker = bindAsyncAction(declineManualDeferredPost)(
  function * (params: DeclineManualDeferredPostRequest) {
    return yield call([DeferredPostApi, DeferredPostApi.declineManualDeferredPost], params)
  },
)

function * watchDeclineManualDeferredPostInitiated () {
  while (true) {
    const action: Action<DeclineManualDeferredPostRequest> = yield take(declineManualDeferredPostInitiated)
    try {
      yield declineManualDeferredPostWorker(action.payload)
    } catch (e) {
      console.log('error in watchDeclineManualDeferredPostInitiated: ', e)
    }
  }
}

// deleteManualDeferredPost
const deleteManualDeferredPostWorker = bindAsyncAction(deleteManualDeferredPost)(
  function * (params: DeleteManualDeferredPostRequest) {
    return yield call([DeferredPostApi, DeferredPostApi.deleteManualDeferredPost], params)
  },
)

function * watchDeleteManualDeferredPostInitiated () {
  while (true) {
    const action: Action<DeleteManualDeferredPostRequest> = yield take(deleteManualDeferredPostInitiated)
    try {
      yield deleteManualDeferredPostWorker(action.payload)
    } catch (e) {
      console.log('error in watchDeleteManualDeferredPostInitiated: ', e)
    }
  }
}

// retryManualDeferredPost
const retryManualDeferredPostWorker = bindAsyncAction(retryManualDeferredPost)(
  function * (params: RetryManualDeferredPostRequest) {
    return yield call([DeferredPostApi, DeferredPostApi.retryManualDeferredPost], params)
  },
)

function * watchRetryManualDeferredPostInitiated () {
  while (true) {
    const action: Action<RetryManualDeferredPostRequest> = yield take(retryManualDeferredPostInitiated)
    try {
      yield retryManualDeferredPostWorker(action.payload)
    } catch (e) {
      console.log('error in watchRetryManualDeferredPostInitiated: ', e)
    }
  }
}

// updateDeferredPost
const updateDeferredPostWorker = bindAsyncAction(updateDeferredPost)(
  function * (params: UpdateDeferredPostRequest) {
    return yield call([DeferredPostApi, DeferredPostApi.updateDeferredPost], params)
  },
)

function * watchUpdateDeferredPostInitiated () {
  while (true) {
    const action: Action<UpdateDeferredPostRequest> = yield take(updateDeferredPostInitiated)
    try {
      yield updateDeferredPostWorker(action.payload)
    } catch (e) {
      console.log('error in watchUpdateDeferredPostInitiated: ', e)
    }
  }
}

export function * googleMyBusinessSagas () {
  yield fork(watchGetGooglePageInitiated)
  yield fork(watchGetGooglePageFeedInitiated)
  yield fork(watchDeletePostInitiated)
  yield fork(watchConfirmManualDeferredPostInitiated)
  yield fork(watchDeclineManualDeferredPostInitiated)
  yield fork(watchDeleteManualDeferredPostInitiated)
  yield fork(watchRetryManualDeferredPostInitiated)
  yield fork(watchUpdateDeferredPostInitiated)
}
